import { Text } from "@react-three/drei"

const CustomText = ({ content, position, fontSize, color, rotation, maxWidth }) => {
  return (
    <Text
      maxWidth={maxWidth}
      rotation={rotation}
      position={position}
      fontSize={fontSize}
      color={color}
      anchorX="center"
      anchorY="middle"
    >
      {content}
    </Text>
  );
};

export {
  CustomText
}